export default __webpack_public_path__ + "static/media/destroy-white.7eb0ba27.yaml";